// @ts-nocheck
(function () {
  'use strict';

  /* ─── Warehouse blocklist ────────────────────────────────── */
  const WAREHOUSE_BLOCKLIST = new Set([
    '5000 - lic warehouse',
    '5200 - mvn warehouse',
  ]);

  /**
   * Canonical retail stores using Figma display names.
   * `aliases` lists the normalized Shopify admin names that map to each store
   * (used for metafield inventory lookup).
   */
  const MASTER_STORES = [
    'Manhattan \u2013 Flatiron Flagship',
    'Brooklyn Industry City Outlet',
    'Greenwich, Connecticut',
  ];

  const STORE_DETAILS = {
    'manhattan \u2013 flatiron flagship': {
      aliases: ['1000 - ny store'],
      image: '//abchome.com/cdn/shop/files/abc_carpet_home_store_888_broadway_990x.jpg?v=1672875142',
      address: '888 Broadway, New York, NY 10003',
      phone: '212-473-3000',
      hours: 'Mon\u2013Sat: 10am\u20137pm \u00b7 Sun: 11am\u20136pm',
    },
    'manhattan \u2013 59th street pop up': {
      aliases: ['1600 - 505 ny pop up'],
      image: '//abchome.com/cdn/shop/files/Screenshot_2025-10-09_at_5.28.54_PM_990x.png?v=1760045351',
      address: '505 Park Avenue, New York, NY 10022',
      phone: '646-602-3700',
      hours: 'Mon\u2013Fri: 10am\u20136:30pm \u00b7 Sat: 10am\u20136pm \u00b7 Sun: Closed',
    },
    'brooklyn industry city outlet': {
      aliases: ['1100 - bk outlet'],
      image: '//abchome.com/cdn/shop/files/73A0321_990x.jpg?v=1682962220',
      address: '220 36th Street, Brooklyn, NY 11232',
      phone: '212-473-3000',
      hours: 'Mon\u2013Sat: 10am\u20136pm \u00b7 Sun: 11am\u20136pm',
    },
    'greenwich, connecticut': {
      aliases: ['1200 - greenwich ct pop up'],
      image: '//abchome.com/cdn/shop/files/Greenwich_Store_990x.jpg?v=1744924801',
      address: '181 Greenwich Avenue, Greenwich, CT 06830',
      phone: '646-602-3500',
      hours: 'Mon\u2013Sat: 10am\u20136pm \u00b7 Sun: 11am\u20135pm',
    },
  };

  /* ─── Utilities ──────────────────────────────────────────── */

  const normalize = (s) => String(s || '').trim().toLowerCase();

  const escHtml = (s) =>
    String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

  /* ─── Pre-escape static store detail strings (run once at init) ── */
  // STORE_DETAILS values never change at runtime — escape them now so
  // #populateDrawer() never has to call escHtml() on them.
  Object.values(STORE_DETAILS).forEach((d) => {
    if (d.address) d.address = escHtml(d.address);
    if (d.phone)   d.phone   = escHtml(d.phone);
    if (d.hours)   d.hours   = escHtml(d.hours);
    if (d.image)   d.image   = escHtml(d.image);
  });

  /* ─── SVG icon constants (defined once, reused on every render) ── */
  const SVG_ADDR = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none"><path d="M8 10C8.55 10 9.02083 9.80417 9.4125 9.4125C9.80417 9.02083 10 8.55 10 8C10 7.45 9.80417 6.97917 9.4125 6.5875C9.02083 6.19583 8.55 6 8 6C7.45 6 6.97917 6.19583 6.5875 6.5875C6.19583 6.97917 6 7.45 6 8C6 8.55 6.19583 9.02083 6.5875 9.4125C6.97917 9.80417 7.45 10 8 10ZM8 17.35C10.0333 15.4833 11.5417 13.7875 12.525 12.2625C13.5083 10.7375 14 9.38333 14 8.2C14 6.38333 13.4208 4.89583 12.2625 3.7375C11.1042 2.57917 9.68333 2 8 2C6.31667 2 4.89583 2.57917 3.7375 3.7375C2.57917 4.89583 2 6.38333 2 8.2C2 9.38333 2.49167 10.7375 3.475 12.2625C4.45833 13.7875 5.96667 15.4833 8 17.35ZM8 20C5.31667 17.7167 3.3125 15.5958 1.9875 13.6375C0.6625 11.6792 0 9.86667 0 8.2C0 5.7 0.804167 3.70833 2.4125 2.225C4.02083 0.741667 5.88333 0 8 0C10.1167 0 11.9792 0.741667 13.5875 2.225C15.1958 3.70833 16 5.7 16 8.2C16 9.86667 15.3375 11.6792 14.0125 13.6375C12.6875 15.5958 10.6833 17.7167 8 20Z" fill="#1B1B1B"/></svg>';
  const SVG_PHONE = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path d="M17.5734 13.4334V15.9334C17.5744 16.1655 17.5268 16.3952 17.4339 16.6079C17.3409 16.8205 17.2045 17.0114 17.0335 17.1683C16.8625 17.3252 16.6606 17.4446 16.4407 17.519C16.2209 17.5934 15.9879 17.621 15.7568 17.6001C13.1925 17.3214 10.7293 16.4452 8.5651 15.0417C6.55162 13.7623 4.84454 12.0552 3.5651 10.0417C2.15675 7.86775 1.2803 5.39258 1.00676 2.81675C0.985939 2.5863 1.01333 2.35405 1.08718 2.13477C1.16104 1.91549 1.27974 1.71399 1.43574 1.5431C1.59173 1.37221 1.7816 1.23567 1.99326 1.14218C2.20491 1.04869 2.43371 1.0003 2.6651 1.00008H5.1651C5.56952 0.9961 5.96159 1.13931 6.26823 1.40302C6.57487 1.66674 6.77516 2.03295 6.83176 2.43341C6.93728 3.23347 7.13297 4.01902 7.4151 4.77508C7.52722 5.07335 7.55148 5.39751 7.48502 5.70915C7.41856 6.02079 7.26415 6.30684 7.0401 6.53341L5.98176 7.59175C7.16806 9.67804 8.89548 11.4055 10.9818 12.5917L12.0401 11.5334C12.2667 11.3094 12.5527 11.155 12.8644 11.0885C13.176 11.022 13.5002 11.0463 13.7984 11.1584C14.5545 11.4405 15.34 11.6362 16.1401 11.7417C16.5449 11.7989 16.9146 12.0028 17.1789 12.3147C17.4432 12.6266 17.5836 13.0247 17.5734 13.4334Z" stroke="#1B1B1B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const SVG_CLOCK = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path d="M9.33333 4.33333V9.33333L12.6667 11M17.6667 9.33333C17.6667 13.9357 13.9357 17.6667 9.33333 17.6667C4.73096 17.6667 1 13.9357 1 9.33333C1 4.73096 4.73096 1 9.33333 1C13.9357 1 17.6667 4.73096 17.6667 9.33333Z" stroke="#1B1B1B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /**
   * Extract a short city-level label from a store display name.
   *   "Manhattan – Flatiron Flagship" → "Manhattan"
   *   "Brooklyn Industry City Outlet"  → "Brooklyn"
   *   "Greenwich, Connecticut"          → "Greenwich"
   */
  const getCityLabel = (name) => {
    let s = String(name || '').trim().replace(/^\d+\s*[-\u2013]\s*/, '');
    const emDash = s.indexOf(' \u2013 ');
    if (emDash > -1) return s.slice(0, emDash);
    const hyph = s.indexOf(' - ');
    if (hyph > -1) return s.slice(0, hyph);
    const comma = s.indexOf(', ');
    if (comma > -1) return s.slice(0, comma);
    const space = s.indexOf(' ');
    return space > -1 ? s.slice(0, space) : s;
  };

  /**
   * Build the PDP trigger message HTML.
   * Store labels are bold; "On Display at" stays normal weight.
   */
  const STORE_MESSAGE_ICON_URL = 'https://cdn.shopify.com/s/files/1/0560/2223/7322/files/store.jpg?v=1776767297&width=40&height=40&crop=center&format=webp';

  const buildMessage = (availableStores) => {
    const labels = [
      ...new Set(availableStores.map((s) => getCityLabel(s.name)).filter(Boolean)),
    ];
    if (!labels.length) return '';
    const icon = `<img src="${escHtml(STORE_MESSAGE_ICON_URL)}" alt="store availability icon" aria-hidden="true" width="20" height="20" style="width:20px;height:20px;object-fit:contain;display:inline-block;vertical-align:text-bottom;margin-right:6px;" loading="lazy" fetchpriority="low" decoding="async">`;
    const bold = (s) => `<strong>${escHtml(s)}</strong>`;
    if (labels.length === 1) return `${icon}On Display at ${bold(labels[0])} Store`;
    if (labels.length === 2) return `${icon}On Display at ${bold(labels[0])} and ${bold(labels[1])} Store`;
    return `${icon}On Display at ${labels.slice(0, -1).map(bold).join(', ')} and ${bold(labels[labels.length - 1])} Store`;
  };

  /* ─── Inventory parsing ──────────────────────────────────── */

  const readRows = (variantMeta) => {
    const raw = variantMeta?.inventory?.available_counts_per_location;
    if (!raw) return [];
    if (Array.isArray(raw)) {
      if (raw.length && Array.isArray(raw[0])) return raw.map((e) => e?.[1]).filter(Boolean);
      return raw;
    }
    if (typeof raw === 'object') return Object.values(raw);
    return [];
  };

  /** Build a normalized-name → quantity map from metafield rows (warehouses excluded). */
  const buildMetafieldMap = (variantMeta) => {
    const map = new Map();
    readRows(variantMeta)
      .map((row) => ({
        name: (row?.name || row?.location?.name || '').trim(),
        quantity: Number(typeof row?.available === 'number' ? row.available : (row?.available ?? 0)) || 0,
      }))
      .filter((r) => r.name && !WAREHOUSE_BLOCKLIST.has(normalize(r.name)))
      .forEach((r) => {
        const key = normalize(r.name);
        map.set(key, (map.get(key) ?? 0) + r.quantity);
      });
    return map;
  };

  /**
   * Memoize metafield map builds by variant index within a product dataset.
   * getStoreStatus() iterates all other variants per store — without caching this
   * is O(stores × variants) map builds per drawer open. With caching: O(variants)
   * on first open, then O(1) per lookup for the lifetime of the page.
   *
   * Cache key is `${variantIndex}:${jsonId}` so different product instances on
   * the same page (edge case) don't collide.
   */
  const _metaMapCache = new Map();
  const getCachedMetaMap = (idx, data, cacheNs) => {
    const key = `${cacheNs}:${idx}`;
    if (!_metaMapCache.has(key)) {
      _metaMapCache.set(key, buildMetafieldMap(data.variants_metafields[idx]));
    }
    return _metaMapCache.get(key);
  };

  /**
   * Look up quantity for a store from the metafield map.
   * Checks both the display name and any `aliases` in STORE_DETAILS.
   */
  const getQtyForStore = (storeName, detail, metaMap) => {
    const keys = [normalize(storeName), ...(detail.aliases || []).map(normalize)];
    return keys.reduce((sum, k) => sum + (metaMap.get(k) ?? 0), 0);
  };

  /**
   * Return MASTER_STORES list with quantities for the current variant.
   * Stores absent from the metafield default to 0.
   */
  const getMasterStores = (variantMeta) => {
    const metaMap = buildMetafieldMap(variantMeta);
    return MASTER_STORES.map((name) => {
      const detail = STORE_DETAILS[normalize(name)] || {};
      return { name, quantity: getQtyForStore(name, detail, metaMap) };
    });
  };

  /**
   * Three-state store availability for the drawer:
   *   'available'   — current variant has stock here
   *   'other'       — current variant OOS but another variant of this product has stock here
   *   'unavailable' — no variant has stock here
   *
   * Uses getCachedMetaMap() so each variant's map is only built once per page load.
   */
  const getStoreStatus = (storeName, currentQty, detail, productData, currentVariantId, cacheNs) => {
    if (currentQty > 0) return 'available';
    if (productData?.variants?.length && productData?.variants_metafields?.length) {
      for (let i = 0; i < productData.variants.length; i++) {
        if (String(productData.variants[i].id) === String(currentVariantId)) continue;
        const otherMap = getCachedMetaMap(i, productData, cacheNs);
        if (getQtyForStore(storeName, detail, otherMap) > 0) return 'other';
      }
    }
    return 'unavailable';
  };

  /** Find the metafield object for a given variant ID. */
  const getVariantMeta = (data, variantId) => {
    if (!data?.variants_metafields) return null;
    const variants = Array.isArray(data.variants) ? data.variants : [];
    const idx = variants.findIndex((v) => String(v.id) === String(variantId));
    return idx > -1 ? (data.variants_metafields[idx] ?? null) : null;
  };

  /* ─── Custom Element ─────────────────────────────────────── */

  class StoreAvailabilityDrawer extends HTMLElement {
    #productData = null;
    #variantId = null;
    #isOpen = false;
    #drawerMounted = false;
    #cacheNs = null;
    $trigger = null;
    $message = null;
    $drawer = null;
    $closeBtn = null;
    $storeList = null;
    $disclaimer = null;
    #lastStores = [];

    // Stored references for proper cleanup in disconnectedCallback
    #observer = null;
    #onVariantChanged = null;
    #onInitialStabilized = null;
    #onKeydown = null;

    connectedCallback() {
      this.#variantId = this.dataset.variantId || null;
      this.#cacheNs   = this.dataset.jsonId || 'default';
      this.$trigger   = this.querySelector('[data-sa-trigger]');
      this.$message   = this.querySelector('[data-sa-message]');
      this.#productData = this.#readData();
      this.#bindEvents();
      this.#render(this.#variantId);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      if (this.#onVariantChanged)    document.removeEventListener('variant:changed', this.#onVariantChanged);
      if (this.#onInitialStabilized) document.removeEventListener('variant:initial-stabilized', this.#onInitialStabilized);
      if (this.#onKeydown)           document.removeEventListener('keydown', this.#onKeydown);
    }

    #readData() {
      const jsonId = this.dataset.jsonId;
      const el =
        (jsonId && document.getElementById(jsonId)) ||
        document.getElementById('product-options-variant-data');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent || '{}');
      } catch (_e) {
        return null;
      }
    }

    #bindEvents() {
      this.$trigger?.addEventListener('click', () => this.#openDrawer());

      this.#onKeydown = (e) => {
        if (e.key === 'Escape' && this.#isOpen) this.#closeDrawer();
      };
      document.addEventListener('keydown', this.#onKeydown);

      // Primary: MutationObserver on ATC button — variant-picker.js calls
      // setAttribute('add-to-cart', variantId) synchronously on every variant change.
      // This is the only signal that fires reliably on every selection.
      const atcBtn = document.querySelector('.product-metas [add-to-cart][add-to-cart-flow]');
      if (atcBtn) {
        this.#observer = new MutationObserver(() => {
          const id = atcBtn.getAttribute('add-to-cart');
          if (id && id !== this.#variantId) this.#render(id);
        });
        this.#observer.observe(atcBtn, { attributes: true, attributeFilter: ['add-to-cart'] });
      }

      // Fallback: variant:changed is dispatched by variant-picker.js only when
      // the gallery instance is unavailable — kept as a safety net.
      this.#onVariantChanged = (e) => {
        const id = e?.detail?.variantId || e?.detail?.variant?.id;
        if (id && String(id) !== this.#variantId) this.#render(String(id));
      };
      document.addEventListener('variant:changed', this.#onVariantChanged);

      // Page-load initializer — variant-picker.js dispatches this after resolving
      // the initial variant from URL params / checked inputs.
      this.#onInitialStabilized = (e) => {
        const id = e?.detail?.variantId;
        if (id) this.#render(String(id));
      };
      document.addEventListener('variant:initial-stabilized', this.#onInitialStabilized);
    }

    #render(variantId) {
      if (!this.#productData || !variantId) {
        this.hidden = true;
        return;
      }

      // Always update #variantId first — before any inventory check.
      // If updated only on the happy path, switching to a zero-inventory variant
      // leaves #variantId at the previous value, so the MutationObserver guard
      // (id !== this.#variantId) blocks the re-render when switching back.
      this.#variantId = variantId;

      const meta      = getVariantMeta(this.#productData, variantId);
      const allStores = getMasterStores(meta);
      const available = allStores.filter((s) => s.quantity > 0);

      if (!available.length) {
        this.hidden = true;
        if (this.#isOpen) this.#closeDrawer();
        return;
      }

      this.#lastStores = allStores;
      this.hidden = false;
      if (this.$trigger) {
        this.$trigger.hidden = false;
        this.$trigger.setAttribute('aria-expanded', String(this.#isOpen));
      }
      if (this.$message) this.$message.innerHTML = buildMessage(available);

      if (this.#isOpen && this.#drawerMounted) {
        this.#populateDrawer(allStores, this.#productData, variantId);
      }
    }

    /**
     * Create the <dialog> portal and set up event delegation for the accordion.
     * Called once on first open — subsequent opens reuse the same DOM.
     */
    #mountDrawer() {
      const drawerId  = `sa-drawer-${Date.now()}`;
      const imgSrc    = this.dataset.productImg    || '';
      const imgAlt    = this.dataset.productImgAlt || '';
      const vendor    = this.dataset.productVendor || '';
      const brandName = this.dataset.brandName     || vendor;
      const title     = this.dataset.productTitle  || '';
      const customText = this.dataset.customText || '';
      const showRugSpecialist = this.dataset.showRugSpecialist === 'true';

      const dialog = document.createElement('dialog');
      dialog.id        = drawerId;
      dialog.className = 'dialog-drawer store-avail__drawer';
      dialog.setAttribute('aria-labelledby', `${drawerId}-title`);
      dialog.innerHTML = `
        <div class="store-avail__drawer-inner">
          <div class="store-avail__drawer-head">
            <p class="store-avail__drawer-title" id="${drawerId}-title">Check Product Availability in Stores</p>
            <button type="button" class="store-avail__close-btn" data-sa-close aria-label="Close">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M12 2L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 12L2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div class="store-avail__product-row">
            ${imgSrc ? `<img class="store-avail__product-img" src="${escHtml(imgSrc)}" alt="${escHtml(imgAlt)}" width="70" height="93" loading="lazy">` : ''}
            <div class="store-avail__product-meta">
              <p class="store-avail__product-brand">${escHtml(brandName)}</p>
              <p class="store-avail__product-name">${escHtml(title)}</p>
            </div>
          </div>
          <ul class="store-avail__list" data-sa-store-list></ul>
          ${customText ? `<p class="store-avail__custom-text">${escHtml(customText)}</p>` : ''}
          ${showRugSpecialist ? `
            <div class="store-avail__rug-specialist products-meta__rug-specialist rug-specialist rug-specialist--default" style="--bg: var(--default);">
              <div class="rug-specialist__header">
                <p class="rug-specialist__heading">Contact a Rug Specialist</p>
                <a class="rug-specialist__button rug-specialist__button--default" href="https://calendly.com/abccarpetandhome" target="_blank" rel="noopener noreferrer">
                  <svg class="symbol-calendar icon rug-specialist__button-icon" aria-hidden="true">
                    <use xlink:href="#icon-calendar"></use>
                  </svg>
                  Book an appointment
                </a>
              </div>
              <div class="rug-specialist__description">
                <p>Our specialists are here to help you choose the perfect, one-of-a-kind rug for your space.</p>
              </div>
            </div>
          ` : ''}
          <p class="store-avail__disclaimer" data-sa-disclaimer></p>
        </div>`;

      document.body.appendChild(dialog);

      this.$drawer     = dialog;
      this.$closeBtn   = dialog.querySelector('[data-sa-close]');
      this.$storeList  = dialog.querySelector('[data-sa-store-list]');
      this.$disclaimer = dialog.querySelector('[data-sa-disclaimer]');

      this.$closeBtn.addEventListener('click', () => this.#closeDrawer());

      // Close on ::backdrop click
      dialog.addEventListener('click', (e) => {
        const rect = dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right ||
            e.clientY < rect.top  || e.clientY > rect.bottom) {
          this.#closeDrawer();
        }
      });

      // Accordion toggle via event delegation (set up once, works for all re-renders)
      this.$storeList.addEventListener('click', (e) => {
        const trigger = e.target.closest('.store-avail__store-trigger');
        if (!trigger) return;
        const item    = trigger.closest('.store-avail__store-item');
        const details = item?.querySelector('.store-avail__store-details');
        if (!details) return;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        item.classList.toggle('is-expanded', !expanded);
        details.hidden = expanded;
      });

      this.#drawerMounted = true;
    }

    /** Render store rows into the drawer list. Called on open and on variant change. */
    #populateDrawer(stores, productData, variantId) {
      if (this.$storeList) {
        this.$storeList.innerHTML = stores.map((store) => {
          const detail = STORE_DETAILS[normalize(store.name)] || {};
          const status = getStoreStatus(store.name, store.quantity, detail, productData, variantId, this.#cacheNs);

          const statusCls = {
            available:   'store-avail__status--available',
            other:       'store-avail__status--other',
            unavailable: 'store-avail__status--unavailable',
          }[status];

          const statusTxt = {
            available:   'Available',
            other:       'Not Available',
            unavailable: 'Not Available',
          }[status];

          // detail.image / .address / .phone / .hours are pre-escaped at init time
          const imgHtml = detail.image
            ? `<img class="store-avail__store-img" src="${detail.image}" alt="${escHtml(store.name)}" width="64" height="64" loading="lazy">`
            : `<div class="store-avail__store-img-placeholder" aria-hidden="true"></div>`;

          const addrLine  = detail.address ? `<p class="store-avail__store-address">${SVG_ADDR}${detail.address}</p>` : '';
          const phoneLine = detail.phone   ? `<p class="store-avail__store-phone">${SVG_PHONE}${detail.phone}</p>`    : '';
          const hoursLine = detail.hours   ? `<p class="store-avail__store-hours">${SVG_CLOCK}${detail.hours}</p>`    : '';
          const hasDetails = addrLine || phoneLine || hoursLine;

          return `
            <li class="store-avail__store-item">
              <button
                type="button"
                class="store-avail__store-trigger"
                aria-expanded="false"
                ${!hasDetails ? 'style="cursor:default"' : ''}
              >
                ${imgHtml}
                <div class="store-avail__store-info">
                  <p class="store-avail__store-name">${escHtml(store.name)}</p>
                  <p class="store-avail__status ${statusCls}">${statusTxt}</p>
                </div>
                ${hasDetails ? `
                <svg class="store-avail__store-chevron" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>` : ''}
              </button>
              ${hasDetails ? `
              <div class="store-avail__store-details" hidden>
                ${addrLine}${phoneLine}${hoursLine}
              </div>` : ''}
            </li>`.trim();
        }).join('');
      }

      if (this.$disclaimer) {
        const ts = new Date().toLocaleString('en-US', {
          month: 'numeric', day: 'numeric', year: 'numeric',
          hour: 'numeric', minute: '2-digit', hour12: true,
        });
        this.$disclaimer.textContent =
          `Disclaimer: Prices and availability are subject to change after the date and time shown on this page (${ts}).`;
      }
    }

    #openDrawer() {
      if (!this.#drawerMounted) this.#mountDrawer();
      this.#populateDrawer(this.#lastStores, this.#productData, this.#variantId);

      this.#isOpen = true;
      this.$trigger?.setAttribute('aria-expanded', 'true');
      this.$drawer.showModal();
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => this.$closeBtn?.focus());
    }

    #closeDrawer() {
      if (!this.$drawer?.open) return;

      this.#isOpen = false;
      this.$trigger?.setAttribute('aria-expanded', 'false');
      this.$drawer.classList.add('dialog-closing');

      this.$drawer.addEventListener(
        'animationend',
        () => {
          this.$drawer.close();
          this.$drawer.classList.remove('dialog-closing');
          document.body.style.overflow = '';
          requestAnimationFrame(() => this.$trigger?.focus());
        },
        { once: true }
      );
    }
  }

  if (!customElements.get('store-availability-drawer')) {
    customElements.define('store-availability-drawer', StoreAvailabilityDrawer);
  }
})();
